'use client'

import 'swiper/css'
import 'swiper/css/effect-cards'

import { FC } from 'react'

import { AnimationShowBlockComponent } from '@/app/shared/components/animation/show-block'
import { AnimationShowTextComponent } from '@/app/shared/components/animation/show-text'
import { BtnCallComponent } from '@/app/shared/components/btn-call'
import { SliderMethodologyComponent } from '@/app/shared/components/teaching-methodology/elements/slider'
import { IconBgPart } from '@/app/shared/icons'
import { IId } from '@/app/shared/interfaces/common.interface'
import {
  IButton,
  IContent,
  IDescription,
  ITitle,
  ITitleEditorList,
} from '@/app/shared/interfaces/content.interface'
import { clearData } from '@/app/shared/services/data-formatter'
import { ContainerComponent } from '@/app/shared/ui/container'
import { TitleComponent } from '@/app/shared/ui/title'

// interface
interface ITeachingMethodology extends IId {
  data: ITeachingMethodologyQuery
}

export interface ITeachingMethodologyQuery {
  arrayTitleEditorImage: {
    items: IContent[]
    title: string | null
  }
  button: IButton
  description: IDescription
  sub_title: {
    sub_title: string
    size: string
  }
  title: ITitle
}

// component
const TeachingMethodologyComponent: FC<Readonly<ITeachingMethodology>> = ({ data, id }) => {
  const arrayTitleEditorImage = clearData(data.arrayTitleEditorImage.items) as ITitleEditorList

  // return
  return (
    <ContainerComponent className={'overflow-hidden'} id={id}>
      <div className={'relative mb-[50px] grid w-full items-stretch tablet:mb-[70px]'}>
        <div
          className={
            'relative mb-[50px] grid w-[calc(100%-30px)] items-end gap-[70px] tablet:flex tablet:justify-between tablet:gap-0 laptop:w-full'
          }
        >
          <TitleComponent className={'order-2 tablet:order-1'} animate>
            {data.title.title}
          </TitleComponent>
          <AnimationShowBlockComponent
            initial={{
              opacity: 0,
              y: 30,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            className={
              'relative right-0 top-0 ml-auto w-full bg-content1-500 p-5 extraMobile:w-[550px] extraMobile:p-[30px] tablet:order-2 tablet:ml-0 large:absolute large:w-[313px]'
            }
            viewport={{
              once: true,
            }}
          >
            <AnimationShowTextComponent
              className={
                'relative z-[1] text-base text-content1-400 tablet:font-semibold desktop:text-[22px]'
              }
            >
              {data.description.description}
            </AnimationShowTextComponent>
            <IconBgPart
              className={
                'absolute -bottom-[35px] right-0 h-[36px] w-[51px] scale-y-[-1] text-content1-500'
              }
            />
          </AnimationShowBlockComponent>
        </div>
        <SliderMethodologyComponent data={arrayTitleEditorImage} />
      </div>
      <BtnCallComponent className={'extraMobile:max-w-[30rem]'} />
    </ContainerComponent>
  )
}

export default TeachingMethodologyComponent
